"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _ExclamationCircleOutlined = _interopRequireDefault(require("@foxui/ui-icons-svg/lib/asn/ExclamationCircleOutlined"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var ExclamationCircleOutlined = function ExclamationCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _ExclamationCircleOutlined.default
  }));
};

/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgN2ExIDEgMCAwMTEgMXY0YTEgMSAwIDExLTIgMFY4YTEgMSAwIDAxMS0xek0xMSAxNmExIDEgMCAwMTEtMWguMDFhMSAxIDAgMTEwIDJIMTJhMSAxIDAgMDEtMS0xeiIgLz48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDEyYTExIDExIDAgMTEyMiAwIDExIDExIDAgMDEtMjIgMHptMTEtOWE5IDkgMCAxMDAgMTggOSA5IDAgMDAwLTE4eiIgZmlsbC1ydWxlPSJldmVub2RkIiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/React.forwardRef(ExclamationCircleOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ExclamationCircleOutlined';
}
var _default = exports.default = RefIcon;